<template>
  <div>
    <yw-head></yw-head>
    <div class="web-body">
      <!--      <my-banner :Mytype="'index'"></my-banner>-->
      <div class="  clearfix product-box">
        <div class="container">
          <div data-v-17932836="" class="content">
            <div data-v-17932836="" class="pro" style="">
              <div data-v-17932836="" class="title">公司简介</div>
              <div data-v-17932836="" class="words">INTRODUCTION</div>
            </div>
            <div data-v-17932836="" class="company" style="">
              <div data-v-17932836="" class="company_des_af"></div>
              <div data-v-17932836="" class="company_des">
                <h3 data-v-17932836="">
                  公司由拥有十余年游戏从业经验的精英团队领衔。旗下拥有多个研发品牌，专业的轻中度游戏发行，亿级用户千万日活的流量平台，形成研发-发行-流量商业闭环模式，专注于轻中度游戏研发与发行，立足于各游戏平台、国内外安卓&amp;iOS市场，已经连续打造众多爆款国内海外产品，走向日韩欧美等多个国家和地区，拥有超过5亿游戏用户。</h3>
                <h3 data-v-17932836="">
                  面对千变万化的市场需求和层出不穷的挑战，公司将秉承“玩家至上”的理念，不断为玩家打造精彩纷呈的精品游戏。</h3>
              </div>
            </div>
          </div>
          <h2 style="font-size:20px;font-weight:bold;text-align: left">旗下优秀产品包括《Dragon Fever TD!》《Psychic Dust -
            Pixel Sandbox》《Brain Go 2》等。</h2>
          <div class="row games">
            <img src="../assets/images/game3.png">
            <img src="../assets/images/game2.png">
            <img src="../assets/images/game1.png">
          </div>
        </div>
      </div>
      <!--      <div class="media-body row clearfix">-->
      <!--        <div class="wrapper cf">-->
      <!--          <h2 style="font-size:17px;font-weight:bold;text-align: center">被顶尖媒体推荐和跟踪报道</h2>-->
      <!--          <div class="row">-->
      <!--            <template v-for="(item) in mediaData">-->
      <!--              <a class="mediaItem" :href="item.url"><img :src="item.img"></a>-->
      <!--            </template>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <yw-footer style="bottom: 0;left:0;position: fixed"></yw-footer>
  </div>
</template>

<script>
import yw_head from './yw_head';
import yw_footer from './yw_footer';
import router from '../router/index';
import banner from './banner';
import axios from 'axios';

export default {
  name: "index",
  data() {
    return {
      indexData: [],
      GetProductUrl: 'https://api.zuiqiangyingyu.cn/a81iWQArSR9sg7b9ih.php/api/website/product/get_index_product_list',
      mediaData: [
        {
          url: 'https://new.qq.com/omn/20180628/20180628A09CRD.html',
          img: require('../assets/images/news1.jpg')
        },
        {
          url: 'http://www.sohu.com/a/297314046_120099888',
          img: require('../assets/images/news2.jpg')
        },
        {
          url: 'https://t.cj.sina.com.cn/articles/view/5788552439/159064cf702000bafx',
          img: require('../assets/images/news3.jpg')
        },
        {
          url: 'http://dy.163.com/v2/article/detail/DI21OH7A0518DFRB.html',
          img: require('../assets/images/news4.jpg')
        },
        {
          url: 'https://36kr.com/p/5140579.html',
          img: require('../assets/images/news5.jpg')
        },
        {
          url: 'http://tech.ifeng.com/a/20180718/45070449_0.shtml',
          img: require('../assets/images/news6.jpg')
        },
        {
          url: 'http://www.moneyweekly.com.cn/MoneyWeekly/Article_21082.html',
          img: require('../assets/images/news7.jpg')
        },
        {
          url: 'http://www.aldzs.com/viewpointarticle?id=662',
          img: require('../assets/images/news8.jpg')
        },
        {
          url: 'https://m.pedaily.cn/news/432957',
          img: require('../assets/images/news9.jpg')
        },
        {
          url: 'http://www.sohu.com/a/238263213_649045 ',
          img: require('../assets/images/news10.jpg')
        }
      ]
    }
  },
  mounted: function () {
    this.GetindexData();
  },
  methods: {
    GetindexData() {
      axios.get(this.GetProductUrl).then((response) => {
            let $data = response.data;
            if ($data.c == 0) {

              this.indexData = $data.d;
            } else {
              alert($data.m)
            }
          }
      ).catch((error) => {
        console.log(error);
      })


    },
    Go() {
      router.push('/experience')
    },
    ChuTi() {
      router.push('/chu_ti')
    }
  },
  components: {
    'my-banner': banner,
    'yw-head': yw_head,
    'yw-footer': yw_footer
  }
}
</script>

<style scoped>
.wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 0px;
  position: relative;
}

.wrapper .mediaItem {
  padding: 0;
  margin: 3.5% 0% 0 0;
  float: left;
  width: 20%;
  text-align: center;
  display: block;
}

.wrapper .mediaItem img {
  max-width: 3rem;
  width: auto;
  /*max-height: 2rem;*/
  height: auto;
}

.container .pro {
  display: flex;
  align-content: flex-end;
  justify-content: flex-start;
  font-family: SourceHanSansCN-Bold;
  font-size: 48px;
  font-weight: 400;
  font-stretch: normal;
  line-height: 48px;
  height: 48px;
  letter-spacing: 0;
  color: #12D2EE;
  margin-right: 10px;
}

.container .pro .title {
  font-size: 40px;
}

.container .pro .words {
  height: 30px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 30px;
  font-weight: 400;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0;
  opacity: .5;
  border-left: 2px solid #fff;
  padding-left: 10px;
  padding-top: 18px;
}

.games img {
  width: 200px;
  height: 200px;
  margin : 20px;
  border-radius: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue